import { createContext } from 'react';
import { type ThemePalette } from './ThemePalette.types';
import commonColors from './CommonColors';

export interface IThemeContext {
  brandLogo: JSX.Element | string;
  brandLogoMobile?: JSX.Element | string;
  brandColor: string;
  brandName: string;
  footerIconColor: string;
  brandStationLabelMobile: string;
  brandStationLabelDesktop: string;
  colorPalette?: ThemePalette;
  colorApplication: {
    bannerLinkGridBackground: string;
    bannerLinkGridColor: string;
  };
}

/**
 * Default theme context
 */
const defaultState = {
  brandLogo: undefined,
  brandLogoMobile: undefined,
  brandColor: '',
  brandName: '',
  brandStationLabelMobile: 'Service station / Truck stop',
  brandStationLabelDesktop:
    'Please enter a Location / Service station / Truck stop',
  colorPalette: commonColors,
  footerIconColor: '',
  colorApplication: {
    bannerLinkGridBackground:
      'linear-gradient(261.59deg,#3129ac -6.6%,#1e196a 79.03%)',
    bannerLinkGridColor: '#ffffff',
  },
};

export const ThemeContext = createContext<IThemeContext>(defaultState);
